






import { Component, Vue } from "vue-property-decorator";

@Component
export default class ContentComponent extends Vue {
  get componentStyle() {
    return {
      "padding-left": this.$store.state.isFolding ? "64px" : "192px"
    };
  }
}
